const store = {
	id: '',
	cause: '',
	location: '',
	image: '',
	title: '',
	price: '',
	beneficiaryInfo: '',
	ngo: '',
	programType: '',
	unitNameSingular: '',
	unitNamePlural: '',
	displayName: '',
	manualQuantity: '',
	donationQuantity: '',
	guestExists: false,
	donors: 0, 
	/**
	 * Matching is a readonly property that's why wraping it into object
	 * : by Priyanshu Jain
	 */
	matching: {
		percentage: 0,
	},
	hasFCRA: 'true',
	program_isNgoReferred: 'false',
	program_Retention: 10,
}

export default store;
